<div [formGroup]="formGroup">
  <div>
    <mat-form-field appearance="outline" floatLabel="always">
      <mat-label>{{ minimum }}</mat-label>
      <input
        matInput
        min="0"
        type="number"
        formControlName="minNumber"
        (change)="fireRangeChangedEvent()"
      />
      @if (formGroup.hasError('rangeError')) {
        <mat-error></mat-error>
      }
      @if (minNumberControl().hasError('numberRange')) {
        <mat-error></mat-error>
      }
    </mat-form-field>
    @if (formGroup.hasError('rangeError')) {
      <mat-error>Minimum value must be less than the maximum value.</mat-error>
    }
    @if (minNumberControl().hasError('numberRange')) {
      <mat-error>{{ minNumberControl().getError('numberRange') }}</mat-error>
    }
  </div>
  <div>
    <mat-form-field appearance="outline" floatLabel="always">
      <mat-label>{{ maximum }}</mat-label>
      <input
        matInput
        min="0"
        type="number"
        formControlName="maxNumber"
        (change)="fireRangeChangedEvent()"
      />
      @if (formGroup.hasError('rangeError')) {
        <mat-error></mat-error>
      }
      @if (maxNumberControl().hasError('numberRange')) {
        <mat-error></mat-error>
      }
    </mat-form-field>
    @if (formGroup.hasError('rangeError')) {
      <mat-error
        >Maximum value must be larger than the minimum value.</mat-error
      >
    }
    @if (maxNumberControl().hasError('numberRange')) {
      <mat-error>{{ maxNumberControl().getError('numberRange') }}</mat-error>
    }
  </div>
</div>
